import styled from 'styled-components'

export const SVITEM = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 10px;
`

export const SVIDet = styled.div`
  display: flex;
  flex-direction: column;
  align-item: flex-start;
  padding: 10px;
`

export const SVIRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 200px;
  justify-content: space-between
`
export const SVImg = styled.img`
  width: 300px;
`
